import React, { useState, useEffect} from 'react';
import './Ballon.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function BallonLearn(props) {
  // Initialize variables to be used later

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [ballons, setBallons] = useState(true);
  const [ballon1, setBallon1] = useState(true);
  const [ballon2, setBallon2] = useState(false);
  const [ballon3, setBallon3] = useState(false);
  const [ballon4, setBallon4] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [effect4, setEffect4] = useState('');
  const [displayLearnVideo, setDisplayLearnVideo] = useState(false);
  const [ballonNum, setBallonNum] = useState(0);
  const [learnVideo, setlearnVideo] = useState('');
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const ballon1Img = generateImageUrl('images/Module16Images/Balloon 1_1.svg');
  const ballon2Img = generateImageUrl('images/Module16Images/Balloon 2_1.svg');
  const ballon3Img = generateImageUrl('images/Module16Images/Balloon 3_1.svg');
  const ballon4Img = generateImageUrl('images/Module16Images/Balloon 4_1.svg');
  const string1Img = generateImageUrl('images/Module16Images/Balloon+String+1.svg');
  const string2Img = generateImageUrl('images/Module16Images/Balloon+String+2.svg');
  const string3Img = generateImageUrl('images/Module16Images/Balloon+String+3.svg');
  const string4Img = generateImageUrl('images/Module16Images/Balloon+String+4.svg');
  const [Exit, setExit] = useState(generateImageUrl('images/Images/close.png'));

  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };
  // CSS code for the back button


  const displayVideo = (video, num) => {
    setlearnVideo(video);
    setBallonNum(num);
    setBallons(false);
    setDisplayLearnVideo(true);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  useEffect(() => {
    sleep(700).then(() => {
      bounceSound.play()
    });
  }, []);

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      <div
        className='ballonScene'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          alt=''
          className='back-btn-ftb'
          src={Exit}
          onClick={() => {
            props.setDisplayLearn(false);
          }}
        ></img>
        {displayLearnVideo && (
          <CloudfrontVideoFormat
            source={learnVideo}
            back={'unit4'}
            background={props.background}
            close={()=>{setDisplayLearnVideo(false); setBallons(true);}}
            ended={() => {
              setDisplayLearnVideo(false);
              setBallons(true);
              if (ballonNum === 1) {
                setEffect1('');
                setEffect2('bounceIcons');
                setBallon2(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              } else if (ballonNum === 2) {
                setEffect2('');
                setEffect3('bounceIcons');
                setBallon3(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              } else if (ballonNum === 3) {
                setEffect3('');
                setEffect4('bounceIcons');
                setBallon4(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              } else if (ballonNum === 4) {
                if (props.module.reviewIcon === false) {
                  dispatch({ type: props.step_completed, payload: 'learn' });
                }
                props.module.sectionCompleted = props.module.sectionCompleted + 1
                props.setDisplayLearn(false);
              } 
            }}
          />
        )}
        {ballons && (
          <div className='crab_ballon'>
            <div className='ballons'>
              {ballon1 && (
                <div
                  className='ballon_string1'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayVideo(props.learnVideo1, 1);
                    });
                  }}
                >
                  <img
                    alt=''
                    className='ballon1'
                    id={effect1}
                    src={ballon1Img}
                  />
                  <br />
                  <img alt='' className='string1' src={string1Img} />
                </div>
              )}
              {ballon2 && (
                <div
                  className='ballon_string2'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayVideo(props.learnVideo2, 2);
                    });
                  }}
                >
                  <img
                    alt=''
                    className='ballon2'
                    id={effect2}
                    src={ballon2Img}
                  />
                  <br />
                  <img alt='' className='string2' src={string2Img} />
                </div>
              )}
              {ballon3 && (
                <div
                  className='ballon_string3'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayVideo(props.learnVideo3, 3);
                    });
                  }}
                >
                  <img
                    alt=''
                    className='ballon3'
                    id={effect3}
                    src={ballon3Img}
                  />
                  <br />
                  <img alt='' className='string3' src={string3Img} />
                </div>
              )}
              {ballon4 && (
                <div
                  className='ballon_string4'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayVideo(props.learnVideo4, 4);
                    });
                  }}
                >
                  <img
                    alt=''
                    className='ballon4'
                    id={effect4}
                    src={ballon4Img}
                  />
                  <br />
                  <img alt='' className='string4' src={string4Img} />
                </div>
              )}
            </div>
            {<img alt='' className='animateAnimal' src={props.animal} />}
          </div>
        )}
      </div>
    </>
  );
}
